import { isAndroid, isMobile } from '../utils';
import { writable } from 'svelte/store';
export function useMobileKeyboard() {
    const isOpen = writable(false);
    const originalHeight = window.innerHeight;
    const applyAfterResize = () => {
        if (isMobile() && isAndroid()) {
            const diff = Math.abs(originalHeight - window.innerHeight);
            isOpen.set(diff > 100);
        }
    };
    window.addEventListener('resize', applyAfterResize);
    return { isOpen };
}
